var map = {
	"./mainNavigationChevron_icon.svg": 1073,
	"./schedule_icon.svg": 1074,
	"./sports_icon.svg": 1075,
	"./table_icon.svg": 1076,
	"./transfers_icon.svg": 1077,
	"./worldnews_icon.svg": 1078
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1267
// module chunks = 30